const info = state => state.info

export default {
  info,
}



// WEBPACK FOOTER //
// ./src/devicehq/store/modules/info/getters.js